import { Guardian, GuardianFilterInput } from "../../../Utilities";

/**
 * @note Does not exclude the given guardianID.
 */
export function getRelatedGuardiansFilterInput(guardianID: Guardian["id"]): GuardianFilterInput {
	return {
		relationships: [
			{
				student: [
					{
						relationships: [
							{
								guardianIDEQ: guardianID,
							},
						],
					},
				],
			},
		],
	};
}
